module.exports = __webpack_public_path__ + "static/esgr-award-9f3ede91f744ae7ced6c9d7bfe351f79.jpg";